const useCheckFiltersValuesDiffer = () => {
    return (filters, filtersInitial, filtersApplied) => {
            let fieldAppliedValuesDiffer = false;
            let fieldInitialValuesDiffer = false;
            for (let filterEntry of Object.keys(filters.filters)) {
                switch (filters.filters[filterEntry].type) {
                    case 'multi-select':
                        switch (filters.filters[filterEntry].config.variant) {
                            case 'list':
                            case 'dropdown':
                                if (true) {
                                    const differApplied = JSON.stringify(filters.filters[filterEntry].value) !== JSON.stringify(filtersApplied.filters[filterEntry].value);

                                    const differInitial = JSON.stringify(filters.filters[filterEntry].value) !== JSON.stringify(filtersInitial.filters[filterEntry].value);
                                    fieldAppliedValuesDiffer = fieldAppliedValuesDiffer || differApplied;
                                    fieldInitialValuesDiffer = fieldInitialValuesDiffer || differInitial;
                                }
                                break
                            default:
                                break
                        }
                        break
                    case 'single-select':
                        switch (filters.filters[filterEntry].config.variant) {
                            case 'list':
                            case 'dropdown':
                                if (true) {
                                    const differApplied = JSON.stringify(filters.filters[filterEntry].value) !== JSON.stringify(filtersApplied.filters[filterEntry].value);
                                    const differInitial = JSON.stringify(filters.filters[filterEntry].value) !== JSON.stringify(filtersInitial.filters[filterEntry].value);
                                    fieldAppliedValuesDiffer = fieldAppliedValuesDiffer || differApplied;
                                    fieldInitialValuesDiffer = fieldInitialValuesDiffer || differInitial;
                                }
                                break
                            default:
                                break
                        }
                        break
                    case 'range': {
                        if (true) {
                            let differApplied = filters.filters[filterEntry].value.lower !== filtersApplied.filters[filterEntry].value.lower;
                            differApplied = differApplied || filters.filters[filterEntry].value.upper !== filtersApplied.filters[filterEntry].value.upper;

                            let differInitial = filters.filters[filterEntry].value.lower !== filtersInitial.filters[filterEntry].value.lower;
                            differInitial = differInitial || filters.filters[filterEntry].value.upper !== filtersInitial.filters[filterEntry].value.upper;
                            fieldAppliedValuesDiffer = fieldAppliedValuesDiffer || differApplied;
                            fieldInitialValuesDiffer = fieldInitialValuesDiffer || differInitial;
                        }
                        break
                    }
                    case 'order': {
                        if (true) {
                            let differApplied = filters.filters[filterEntry].value.value !== filtersApplied.filters[filterEntry].value.value;
                            differApplied = differApplied || filters.filters[filterEntry].value.ascending !== filtersApplied.filters[filterEntry].value.ascending;
                            let differInitial = filters.filters[filterEntry].value.value !== filtersInitial.filters[filterEntry].value.value;
                            differInitial = differInitial || filters.filters[filterEntry].value.ascending !== filtersInitial.filters[filterEntry].value.ascending;
                            fieldAppliedValuesDiffer = fieldAppliedValuesDiffer || differApplied;
                            fieldInitialValuesDiffer = fieldInitialValuesDiffer || differInitial;
                        }
                        break
                    }
                    default:
                        break
                }
            }
            return {fieldAppliedValuesDiffer, fieldInitialValuesDiffer}
    }
}

export default useCheckFiltersValuesDiffer;
